<template>
  <div v-if="!removed" class="item">
    <h5>
      <span  
        v-html="documentIcon(item.document_type)"
        :title="doc_labels[item.document_type]"
        style="padding-right:.25rem">
      </span>
      <a :href="item.url">{{ item.title }}</a>
    </h5>
    <p v-html="item.extract" class="no-margin extract"></p>
    <p class="url no-margin">
      <a :href="item.url">{{ item.url }}</a>
      <span 
        v-if="sat === true"
        style="margin-left: 1rem">
        <a @click.prevent="removeItem(item.url)" href="#">
          <span style="color:#666;white-space:nowrap">[ 
            {{ removeLabel }} 
          ]</span>
        </a>
      </span>
    </p>
  </div>
</template>

<script>
import axios from 'axios'

export default { 
  name: 'ResultItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    sat: {
      type: Boolean
    }
  },
  data () {
    return {
      doc_labels: {
        excel: 'Excel spreadsheet',
        html: 'Web page',
        pdf: 'PDF document',
        word: 'Word document'
      },
      busy: false,
      remove: false,
      removed: false
    }
  },
  methods: {
    documentIcon (doc_type) {
      switch (doc_type) {
        case 'pdf':
          return this.$icons.get('pdf', 'large red')
        case 'word':
          return this.$icons.get('word', 'large blue')
        case 'excel':
          return this.$icons.get('excel', 'large green')
        case 'powerpoint':
          return this.$icons.get('powerpoint', 'large ppt')
        default:
          return this.$icons.get('page', 'large dark-gray')
      }
    },
    removeItem (url) {
      if (!this.remove) {
        this.remove = true
        return
      }

      if (!this.busy) {
        this.busy = true

        axios.post('/oss/remove', {
          instance: 'intranet',
          action: 'remove',
          urls: [
            url
          ],
          responseType: 'json'
        })
        .then(function(response) {
          if (response.data.success) {
            this.removed = true
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error)
        }.bind(this))
        .finally(function () {
          this.busy = false
        }.bind(this))
      }
    }
  },
  computed: {
    removeLabel () {
      if (this.busy) {
        return 'removing...'
      }
      if (this.remove) {
        return 'Are you sure?'
      }
      return 'remove from index'
    }
  }
}
</script>
